import styled from '@emotion/styled'
import { useEffect } from 'react'

import { MessageBox, Space } from '../../../../../components/core-v2'
import { useAppSelector } from '../../../store/hooks'
import { useActions } from '../../../store/use-actions'
import { formatFees } from '../../../util'
import { DetailsSummary } from '../existing-note/details-summary'
import { actions as rawActions } from '../existing-note/existing-note-slice'

const StyledDraftTradeNote = styled.div`
  * {
    background: var(--Transparent);
  }
`

const NoteDetailsSummary = () => {
  const builderState = useAppSelector(state => state.existingNote)
  const noteState = useAppSelector(state => state.note)
  const actions = useActions(rawActions)

  useEffect(() => {
    if (noteState) {
      const { note } = noteState
      actions.init(note)
    }
  }, [actions, noteState, noteState.note])

  return (
    <>
      {builderState && builderState.note && (
        <Space mx={5} my={6}>
          <StyledDraftTradeNote>
            <DetailsSummary
              asModal={false}
              businessUnit={builderState.businessUnit}
              client={builderState.client}
              fees={formatFees(builderState.note.fees)}
              note={builderState.note}
            />
          </StyledDraftTradeNote>
        </Space>
      )}
      {(builderState === undefined || builderState.note === undefined) && (
        <Space mx={5} my={6}>
          <MessageBox state="warning" title="We are unable to display note details">
            Please edit and add note details
          </MessageBox>
        </Space>
      )}
    </>
  )
}

export default NoteDetailsSummary
